import e from"./user";import r from"./user-link";e.Link=r;export{StyledUser,StyledUserInfo,StyledUserName,StyledUserDesc}from"./user.styles";export default e;